import { css } from "@emotion/css";
import { OnboardingDialog } from "@octopusdeploy/design-system-components";
import { fontWeight, text } from "@octopusdeploy/design-system-tokens";
import type { LicenseUsageResource } from "@octopusdeploy/octopus-server-client";
import { nameForLink, useDispatchLinkClicked } from "@octopusdeploy/portal-routes";
import { OctoLink } from "@octopusdeploy/utilities";
import type { ReactNode } from "react";
import React from "react";
import { LicenseUsageOverview } from "~/areas/configuration/components/LicenseUsage/LicenseUsageOverview";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { UpsellDialogWithLicenseUsageIllustration } from "~/components/UpsellDialog/UpsellDialogWithLicenseUsageIllustration";
export interface UpsellDialogWithLicenseUsageProps {
    title: string;
    content: ReactNode | string;
    open: boolean;
    onClose: () => void;
    licenseSerialNumber: string | undefined;
    licenseUsage?: LicenseUsageResource | null;
}
export const UpsellDialogWithLicenseUsage = ({ title, content, open, onClose, licenseSerialNumber, licenseUsage }: UpsellDialogWithLicenseUsageProps) => {
    const isFreeTierEnabled = isFeatureToggleEnabled("free-tier");
    const dispatchLinkClicked = useDispatchLinkClicked();
    if (!isFreeTierEnabled)
        return <></>;
    const upgradeLinkLabel = "Upgrade";
    const upgradePlanLink = OctoLink.Create(`plan-upgrade?serial=${licenseSerialNumber}`);
    return (<OnboardingDialog title={title} open={open} onClose={onClose} primaryButtonProps={{
            label: upgradeLinkLabel,
            href: upgradePlanLink,
            external: true,
            onClick: () => dispatchLinkClicked(nameForLink(), {
                linkLabel: upgradeLinkLabel,
                documentUrl: upgradePlanLink,
            }),
        }} secondaryButtonProps={{ label: "Maybe Later", onClick: onClose }} sidePanelImage={<UpsellDialogWithLicenseUsageIllustration />}>
            <p className={styles.paragraph}>{content}</p>
            <LicenseUsageOverview licenseUsage={licenseUsage}/>
        </OnboardingDialog>);
};
const styles = {
    paragraph: css({
        font: text.body.regular.large,
        "& strong": {
            fontWeight: fontWeight[700],
        },
    }),
};
